export default [
  {
    path: '/new-student-unpaids',
    name: 'new-student-unpaid',
    meta: { requiresAuth: true },
    component: () => import('@/pages/new-student-unpaid/index.vue')
  }
]
